var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlinkingStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50478 16.5748L0.570764 16.178L6.50478 15.7804C11.7531 15.4293 15.9323 11.2563 16.2832 6.01573L16.6814 0.0904641L17.0788 6.01573C17.4305 11.2563 21.6097 15.4293 26.858 15.7804L32.792 16.178L26.858 16.5748C21.6097 16.926 17.4305 21.099 17.0788 26.3395L16.6814 32.2648L16.2832 26.3395C15.9323 21.0983 11.7531 16.9253 6.50478 16.5748Z",
    fill: "#DDCBA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlinkingStars);
export default __webpack_public_path__ + "static/media/blinking-stars.960bb4c44ed6b3d5363085e3af4a3ec6.svg";
export { ForwardRef as ReactComponent };